import styled from 'styled-components';
import { Text } from '@makerdao/ui-components-core';

const TextMono = styled(Text)`
  font-family: Gilroy Regular;
`;

export default TextMono;
